"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _Button = _interopRequireDefault(require("@concur/nui-widgets/lib/Buttons/Button"));
var _analytics = require("../../../../constants/analytics");
var _config = _interopRequireDefault(require("../../../../config"));
var _styles = require("../../styles");
var _ConnectedMessage = _interopRequireDefault(require("./sharedComponents/ConnectedMessage"));
var _ConnectButton = _interopRequireDefault(require("./sharedComponents/ConnectButton"));
var _InfoLinkAndDescription = _interopRequireDefault(require("../../common/InfoLinkAndDescription"));
var _DRCInfoLinkAndDescription = _interopRequireDefault(require("../../common/DRCInfoLinkAndDescription"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function AdminListingConnectionSection(_ref) {
  var listing = _ref.listing,
    isDisabled = _ref.isDisabled,
    isConnecting = _ref.isConnecting,
    onConnectButtonClick = _ref.onConnectButtonClick,
    onDisconnectButtonClick = _ref.onDisconnectButtonClick,
    profile = _ref.profile,
    _onRequestInformationClick = _ref.onRequestInformationClick,
    isTestEntity = _ref.isTestEntity;
  var ID = listing.ID,
    _listing$core = listing.core,
    isUserConnected = _listing$core.isUserConnected,
    canUserConnect = _listing$core.canUserConnect,
    dnfRequired = listing.dnfRequired,
    dnfCompleted = listing.dnfCompleted;
  var userIsAdmin = (profile === null || profile === void 0 ? void 0 : profile.Role) === 1 || (profile === null || profile === void 0 ? void 0 : profile.Role) === 2;
  var isDRCListing = _config.default.nui.DRCListingId === ID;

  // This indicates if the user is subject to potential listing connection blocking
  var blockIncompleteDnf = (_config.default.nui.forceIncompleteDnfConnectionBlocking || _config.default.nui.enableIncompleteDnfConnectionBlocking && (profile === null || profile === void 0 ? void 0 : profile.betas['dnf-consumer'])) && !isTestEntity;
  // This indicates if the listing connection is blocked due to incomplete dnf
  var isConnectionBlocked = blockIncompleteDnf && dnfRequired && !dnfCompleted;
  var disableConnectButton = isDisabled || !userIsAdmin || isConnecting || isConnectionBlocked;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isUserConnected && /*#__PURE__*/_react.default.createElement(_ConnectedMessage.default, null), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, !isUserConnected && userIsAdmin && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "ActivateBusinessApp"
  })), /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "ConnectBusinessApp"
  })), !isUserConnected && canUserConnect && /*#__PURE__*/_react.default.createElement(_ConnectButton.default, {
    onClick: onConnectButtonClick,
    disabled: disableConnectButton,
    renderSpinner: isConnecting,
    italicFont: disableConnectButton
  }), !isUserConnected && userIsAdmin && isConnectionBlocked && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "AppCenterV2.listing.dnfExplanation"
  })), !isUserConnected && !userIsAdmin && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "EndUserConnectBusinessApp"
  })), isUserConnected && userIsAdmin && /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onDisconnectButtonClick,
    style: _styles.BUTTON_STYLE,
    innerProps: {
      className: 'max-button-width'
    }
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "Disconnect"
  })), isDRCListing && /*#__PURE__*/_react.default.createElement(_DRCInfoLinkAndDescription.default, {
    onRequestInformationClick: function onRequestInformationClick() {
      _nuiLogger.default.info({
        description: 'New request information clicked on DRC listing',
        'cte.subcategory': 'new-request-info-button-click'
      });
      _onRequestInformationClick(_analytics.elementList.link);
    }
  }), !isDRCListing && /*#__PURE__*/_react.default.createElement(_InfoLinkAndDescription.default, {
    onRequestInformationClick: function onRequestInformationClick() {
      _nuiLogger.default.info({
        description: "New request information link for admin listing clicked on listing ".concat(ID),
        'cte.subcategory': 'new-request-info-button-click'
      });
      _onRequestInformationClick(_analytics.elementList.link);
    }
  })));
}
AdminListingConnectionSection.propTypes = {
  listing: _propTypes.default.shape({
    ID: _propTypes.default.string.isRequired,
    core: _propTypes.default.shape({
      isUserConnected: _propTypes.default.bool.isRequired,
      canUserConnect: _propTypes.default.bool
    }).isRequired,
    dnfRequired: _propTypes.default.bool,
    dnfCompleted: _propTypes.default.bool
  }).isRequired,
  isDisabled: _propTypes.default.bool,
  isConnecting: _propTypes.default.bool,
  onConnectButtonClick: _propTypes.default.func.isRequired,
  onDisconnectButtonClick: _propTypes.default.func.isRequired,
  profile: _propTypes.default.shape({
    Role: _propTypes.default.number
  }).isRequired,
  onRequestInformationClick: _propTypes.default.func.isRequired,
  isTestEntity: _propTypes.default.bool
};
var _default = exports.default = AdminListingConnectionSection;